import React from "react";
import { allCatalogCoursesSelected, newGestorCursoRow } from "./gestorUsuarioCursosState";
import ViewportSelect from "../../../components/ViewportSelect";

/**
 * @typedef {{ _id: string; titulo: string }} CursoDisponible
 * @typedef {{ id: string; cursoId: string }} CursoRow
 */

/**
 * @param {{
 *   rows: CursoRow[];
 *   setRows: React.Dispatch<React.SetStateAction<CursoRow[]>>;
 *   cursosDisponibles: CursoDisponible[];
 *   loadError?: string;
 * }} props
 */
function GestorUsuarioCursosEditor({ rows, setRows, cursosDisponibles, loadError = "" }) {
  const totalCursos = cursosDisponibles.length;
  const allCoursesSelected = allCatalogCoursesSelected(rows, cursosDisponibles);

  const resolveTitulo = (cursoId) => {
    if (!cursoId) return "";
    const found = cursosDisponibles.find((curso) => String(curso._id) === String(cursoId));
    return found?.titulo ?? "";
  };

  return (
    <div className="gus-cursos-field">
      <p className="gus-cursos-help">
        Añade o quita cursos. Los cambios se aplicarán al guardar el perfil del usuario.
      </p>
      {loadError ? (
        <p className="gus-cursos-help gus-cursos-load-error" role="alert">
          {loadError}
        </p>
      ) : null}
      <ul className="gus-cursos-cards">
        {rows.map((row) => {
          const takenElsewhere = new Set(
            rows
              .filter((entry) => entry.id !== row.id && entry.cursoId !== "")
              .map((entry) => entry.cursoId),
          );
          const cardTitle = resolveTitulo(row.cursoId);
          return (
            <li key={row.id} className="gus-curso-card">
              <div className="gus-curso-card-header">
                <span className="gus-curso-card-label">
                  {cardTitle || "Curso sin seleccionar"}
                </span>
                <button
                  type="button"
                  className="gus-curso-card-remove"
                  onClick={() => {
                    setRows((prev) => {
                      if (prev.length <= 1) {
                        return [{ ...prev[0], cursoId: "" }];
                      }
                      return prev.filter((entry) => entry.id !== row.id);
                    });
                  }}
                  aria-label="Quitar curso"
                >
                  Quitar
                </button>
              </div>
              <ViewportSelect
                className="form-control gus-curso-card-select"
                value={row.cursoId}
                onChange={(e) => {
                  const value = e.target.value;
                  setRows((prev) =>
                    prev.map((entry) =>
                      entry.id === row.id ? { ...entry, cursoId: value } : entry,
                    ),
                  );
                }}
                aria-label="Seleccionar curso"
              >
                <option value="">Selecciona un curso</option>
                {cursosDisponibles.map((cursoItem) => {
                  const courseId = String(cursoItem._id);
                  const disabled = takenElsewhere.has(courseId) && row.cursoId !== courseId;
                  return (
                    <option key={courseId} value={courseId} disabled={disabled}>
                      {cursoItem.titulo}
                      {disabled ? " (ya asignado)" : ""}
                    </option>
                  );
                })}
              </ViewportSelect>
            </li>
          );
        })}
      </ul>
      {!allCoursesSelected && totalCursos > 0 ? (
        <button
          type="button"
          className="gus-curso-add"
          onClick={() => setRows((prev) => [...prev, newGestorCursoRow()])}
        >
          Añadir curso
        </button>
      ) : null}
    </div>
  );
}

export default GestorUsuarioCursosEditor;
